import React, { useEffect, useRef, useState } from 'react'
import { Box, IconButton } from '@material-ui/core'
import Icon from '@mdi/react'
import { mdiImagePlusOutline } from '@mdi/js'
import { arrayBufferToBase64 } from 'web/src/utils/bufferToBase64'
import { mdiWindowClose } from '@mdi/js'
import { makeStyles } from '@material-ui/core/styles'
import { AvatarView } from './avatar-view'
import { ImagePlusIcon } from 'lucide-react'

export const useStyles = makeStyles(theme => ({
    container: {
        position: 'relative',
        height: '40px',
        display: 'flex',
        alignItems: 'center'
    },
    iconStyles: {
        width: 12,
        height: 12,
        cursor: 'pointer',
        color: theme.primary
    },
    removeIconWrapper: {
        cursor: 'pointer',
        position: 'absolute',
        right: '-10px',
        top: '-10px',
        width: 18,
        height: 18,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '50%',
        backgroundColor: theme.background,
        border: `0.5px solid ${theme.secondary}`,
        '&:hover': {
            backgroundColor: theme.secondary
        },
        zIndex: 9999
    },
    image: {
        width: '100%',
        height: 'inherit',
        objectFit: 'cover'
    }
}))

export const ImageUpload = ({
    imagesForUpload,
    setImagesForUpload,
    deletedPictureKeys,
    setDeletedPictureKeys,
    data,
    indexOfCommentCard,
    isEdit,
    kind,
    isModalOpen,
    setIsModalOpen,
    loading,
    permissions
}) => {
    const [img, setImg] = useState(null)
    const inputRef = useRef(null)

    const classes = useStyles()

    useEffect(() => {
        if (data?.Body) {
            return setImg(
                `data:image/jpeg;base64,${arrayBufferToBase64(data.Body?.data)}`
            )
        }

        if (data) {
            const reader = new FileReader()

            reader.readAsDataURL(data)
            reader.onloadend = function() {
                setImg(reader.result)
            }
        }
    }, [data])

    const onChangeHandler = e => {
        const files = e.target.files
        if (files?.length) {
            if (imagesForUpload[indexOfCommentCard]) {
                const newArr = [...imagesForUpload]
                newArr[indexOfCommentCard] = files
                setImagesForUpload(newArr)
            } else {
                setImagesForUpload([...imagesForUpload, ...files])
            }
        }
    }

    const onInputClickHandler = e => {
        if (deletedPictureKeys?.length) {
            setDeletedPictureKeys([...deletedPictureKeys, data])
        }
        if (e) {
            e.target.value = null
        }
    }

    return (
        <Box className={classes.container} color="primary" component="label">
            {!isEdit && (
                <input
                    onClick={e => {
                        setIsModalOpen && e.preventDefault()
                        if (setIsModalOpen && permissions.updateDevice) {
                            setIsModalOpen(true)
                        } else if (!setIsModalOpen) {
                            onInputClickHandler()
                        }
                    }}
                    hidden
                    ref={inputRef}
                    accept="image/*"
                    type="file"
                    onChange={onChangeHandler}
                />
            )}
            {!data && kind !== 'avatar' && !loading && (
                <IconButton
                    onClick={() => {
                        inputRef?.current?.click()
                    }}
                >
                    <ImagePlusIcon size={24} />
                </IconButton>
            )}
            {kind === 'avatar' && (
                <AvatarView
                    onClick={() => {
                        !imagesForUpload.length && inputRef?.current?.click()
                    }}
                    path={mdiImagePlusOutline}
                    imagesForUpload={imagesForUpload}
                    isModalOpen={isModalOpen}
                    setIsModalOpen={setIsModalOpen}
                    loading={loading}
                    permissions={permissions}
                />
            )}
            {img && (
                <img
                    className={classes.image}
                    src={img}
                    onClick={e => e.preventDefault()}
                />
            )}
            {isEdit && (
                <div
                    className={classes.removeIconWrapper}
                    onClick={e => {
                        e.preventDefault()

                        setImagesForUpload(
                            imagesForUpload?.filter(
                                item =>
                                    item !==
                                    imagesForUpload?.[indexOfCommentCard]
                            )
                        )

                        setDeletedPictureKeys([...deletedPictureKeys, data])
                    }}
                >
                    <Icon
                        className={`${classes.iconStyles} show-icon`}
                        path={mdiWindowClose}
                    />
                </div>
            )}
        </Box>
    )
}
